import React from "react";
import { Typography, Grid, Box } from "@material-ui/core";
import CoreAppBar from "../component_library/CoreAppBar";
import Footer from "../component_library/Footer";

interface IProps {}

const ArtistNotFound: React.FC<IProps> = () => {
  return (
    <>
      <CoreAppBar />
      <Box p={2} mt={2} textAlign="center">
        <Grid container justify="center">
          <Grid item xs sm={6}>
            <Typography variant="h3">Artist Not Found</Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </>
  )
};

export default ArtistNotFound;
